import { SlashCommand } from './types';

export const tiktokArchiverCommands: SlashCommand[] = [
    {
        id: 'ttarchive',
        name: 'TikTok Archive',
        trigger: '/ttarchive',
        description: 'Download and archive an entire TikTok channel.',
        category: 'TikTok Archiver',
        icon: 'fa-tiktok',
        integration: 'TikTok Archiver',
        mode: 'tool',
        tool: 'tiktok-archiver',
        prefix: 'archive this tiktok channel: '
    }
];
